import { useQuery } from "@apollo/react-hooks";
import {
  GetResponseTimelineByCountry,
  GetResponseTimelineByCountryVariables,
} from "../../../apollo-types/GetResponseTimelineByCountry";
import { RESPONSE_TIMELINE_BY_COUNTRY } from "./query";

export const useQueryGovResTimeline = (country: string) => {
  const { data, loading } = useQuery<
    GetResponseTimelineByCountry,
    GetResponseTimelineByCountryVariables
  >(RESPONSE_TIMELINE_BY_COUNTRY, {
    variables: { country },
  });

  const returnedCountry = data?.responsesChangeTimelineByCountry?.name;
  const responseTimeline =
    returnedCountry === country ? data?.responsesChangeTimelineByCountry : null;

  return { loading, responseTimeline };
};
